import { setSelectors, assignListeners, removeListeners } from './utilities.js';

class QuickCartTrigger extends HTMLElement {

  constructor() {
    super();
    this.events = {};
    this.selectors = {};
  };

  connectedCallback() { this._initialize(); };

  disconnectedCallback() { this._deinitialize(); };

  handleClick = (_e) => {
    const quickCartOpenEvent = window.umbrellaConfig.events.qcOpen || 'quickCart:open';
    document.dispatchEvent(new CustomEvent(quickCartOpenEvent));
  };

  updateCount = (event) => {
    if(!event || !event.detail) return;
    const detail = event.detail || {};
    const cart = detail.cart;
    if(!cart || typeof cart.item_count !== 'number' || !this.selectors.count) return;
    const count = cart.item_count;
    this.selectors.count.textContent = count > 0 ? count : '';
    if(this.selectors.countText) {
      this.selectors.countText.textContent = count > 0 ? `${count} item${count === 1 ? '' : 's'} in cart` : 'Cart empty';
    }
  };

  _initialize = () => {
    this.selectors = setSelectors(this, { button: 'button', count: '[data-cart-item-count]', countText: '[data-cart-count-text]' });
    if(!this.selectors.button || !this.selectors.count) return;
    const cartChangeEvt = window.umbrellaConfig.events.cartChange || 'cart:state';
    assignListeners(this.selectors.button, { click: this.handleClick });
    assignListeners(document, { [cartChangeEvt]: this.updateCount });
  };

  _deinitialize = () => {
    const cartChangeEvt = (this.events && this.events.cartChange) || 'cart:state';
    if(this.selectors && this.selectors.button) removeListeners(this.selectors.button, { click: this.handleClick });
    removeListeners(document, { [cartChangeEvt]: this.updateCount });
  };

};

customElements.define('quick-cart-trigger', QuickCartTrigger);